module.exports = __webpack_public_path__ + "static/img/z_proposal1.e8c23c4.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/ce/z_proposal1.jpg
// module id = tZsW
// module chunks = 171